export const ERROR_BULK_UPDATE_SCOPE_ELEMENTS = 'ERR_0001';
